import { createFileRoute } from '@tanstack/react-router';

import { ErrorComponent } from '@/components/common/ErrorComponent';
import { useSetBreadcrumbs } from '@/components/layout/breadcrumbs';

import { LinkedInExtensionPage } from './-components/LinkedInExtensionPage';

function LinkedInExtensionRoute() {
  useSetBreadcrumbs([{ label: 'Settings' }, { label: 'LinkedIn extension' }]);
  return <LinkedInExtensionPage />;
}

export const Route = createFileRoute('/settings/linkedin-extension')({
  component: LinkedInExtensionRoute,
  errorComponent: ErrorComponent,
});
